// Dependencias generales
import React from "react";
import { useEffect , useState, useRef} from 'react';
import ConfiguredApplicationsList from "./ConfiguredApplicationsList";
import AppDeletionError from "./AppDeletionError";
import AvailableApplicationsList from "./AvailableApplicationsList";
import AvailableDevicesList from "./AvailableDevicesList";
import AppRegistrationForm from "./AppRegistrationForm";
import GoogleMapComponentLocation from "../Utils/GoogleMapComponentLocation.js";

import imgCalculadoraPotencias from '../../img/Potencias.png'
import imgCalculadoraTarifas from '../../img/Tarifas.png'
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";


var initialConfigCommonJS = require("../../js/initialConfigCommon.js");

// Función del router
const AsideMenu = (params) => {

  const [availableApps, setAvailableApps] = useState([])
  const [appToRegister, setAppToRegister] = useState("")
  const [availableDevices, setAvailableDevices] = useState([])
  const [deletionConflictDevices, setDeletionConflictDevices] = useState([])
  const [selecteDeviceToConfigure, setSelecteDeviceToConfigure] = useState("")
    
  const [markers, setMarkers] = useState([]);

  useEffect(() => {   
    
    if (params.devicesList === undefined) {
      console.log("Menu normal")
    }
    else{
      console.log("Menu página dispositivos")                  

      setAppToRegister(params.appToConsult)
      setAvailableDevices(params.devicesList)
      
    }

  }, [params.devicesList, params.appToConsult]);

  document.addEventListener("mousedown", (event) => {        
    if(event.target.id  === "menuLateral"){
      initialConfigCommonJS.operarMenuLateral("cerrar")
    }
  });    

  const inputRef = useRef();

  const handlePlaceChanged = () => { 
    const [ place ] = inputRef.current.getPlaces();

    if(place) {      

      var codigoPostal = ""      

      for(var x=0; x < place.address_components.length; x++){
        if(place.address_components[x].types[0] === "postal_code"){
          codigoPostal = place.address_components[x].long_name    
        }
      }         

      document.getElementById("codigoPostalUbicacion").value = codigoPostal

      params.setSelectedLocation([{ id: "", distance: "", lat: place.geometry.location.lat(), long: place.geometry.location.lng() }]) 

      setMarkers(() => [      
        {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng())
        }
      ]);
      
      document.getElementById("latitudUbicacion").value = place.geometry.location.lat()
      document.getElementById("longitudUbicacion").value = place.geometry.location.lng()   
    } 
  }

  function setearPrecioPotencia(){
    
    document.getElementById("potenciaContratada").value = ""

    var camposVisiblesVacios = 0

    for(var z=0; z<6; z++){
      
      if( !document.getElementById("trPotenciaP"+(z+1)).className.includes(" hidden") && document.getElementById("PotenciaP"+(z+1)).value === "" ){
        document.getElementById("PotenciaP"+(z+1)).className = document.getElementById("PotenciaP"+(z+1)).className.replaceAll(" error","") + " error"
        camposVisiblesVacios++
      }

      if( !document.getElementById("trPotenciaP"+(z+1)).className.includes(" hidden") && document.getElementById("precioPotenciaP"+(z+1)).value === "" ){
        document.getElementById("precioPotenciaP"+(z+1)).className = document.getElementById("precioPotenciaP"+(z+1)).className.replaceAll(" error","") + " error"
        camposVisiblesVacios++
      }

    }

    if(camposVisiblesVacios === 0){
      
      var datosCorrectos = true
    
      for(var y=0; y<6; y++){

        document.getElementById("PotenciaP"+(y+1)).value = document.getElementById("PotenciaP"+(y+1)).value.replaceAll(" ","").replaceAll(",",".")
        document.getElementById("precioPotenciaP"+(y+1)).value = document.getElementById("precioPotenciaP"+(y+1)).value.replaceAll(" ","").replaceAll(",",".")

        if( (document.getElementById("PotenciaP"+(y+1)).value !== "") && (document.getElementById("precioPotenciaP"+(y+1)).value !== "") ){      
          if( parseFloat(document.getElementById("PotenciaP"+(y+1)).value) < parseFloat(document.getElementById("precioPotenciaP"+(y+1)).value) ){
            initialConfigCommonJS.mostrarMensajeInformativo("Creo que has introducido los datos al revés, revisa las unidades e introduce consumo y tarifa en sus campos correspondientes.","negative")
            datosCorrectos = false        
          }
          else if( parseFloat(document.getElementById("precioPotenciaP"+(y+1)).value) >= 0.5){
            initialConfigCommonJS.mostrarMensajeInformativo("Alguna de las tarifas de la potencia contratada son incorrectas. Normalmente son valores de céntimos inferiores a 0,5€.","negative")
            datosCorrectos = false        
          }
        }
      }

      if(datosCorrectos){

        var camposPotencia = 0

        for(var x=0; x<6; x++){
          if( (document.getElementById("PotenciaP"+(x+1)).value.toString() !== "") && (document.getElementById("precioPotenciaP"+(x+1)).value.toString() !== "") ){                        
            document.getElementById("potenciaContratada").value = document.getElementById("potenciaContratada").value + document.getElementById("PotenciaP"+(x+1)).value + "|" + document.getElementById("precioPotenciaP"+(x+1)).value + "#"
            camposPotencia++
          }
        }

        if(document.getElementById("potenciaContratada").value.charAt(document.getElementById("potenciaContratada").value.length - 1) === "#"){
          document.getElementById("potenciaContratada").value = document.getElementById("potenciaContratada").value.substring(0,(document.getElementById("potenciaContratada").value.length - 1))
        }

        initialConfigCommonJS.mostrarPotenciaEnTabla(document.getElementById("potenciaContratada").value)         
        document.getElementById("tablaPotenciaContratada").className = document.getElementById("tablaPotenciaContratada").className.replaceAll(" hidden", "")


        if(camposPotencia === 1){
          document.getElementById("spanPotenciaP1").innerHTML ="P1 : Punta | Llano | Valle"          
        }  

        if(camposPotencia === 2){
          document.getElementById("spanPotenciaP1").innerHTML ="P1 : Punta | Llano"
          document.getElementById("spanPotenciaP2").innerHTML ="P2 : Valle"
        }  
    
        if(camposPotencia === 6){
          document.getElementById("spanPotenciaP1").innerHTML ="P1 :"
          document.getElementById("spanPotenciaP2").innerHTML ="P2 :"
          document.getElementById("spanPotenciaP3").innerHTML ="P3 :"
        }  

        if(localStorage.getItem("installationConfigurationMode") !== null){
          initialConfigCommonJS.mostrarMensajeInformativo('Recuerda usar el botón "Guardar configuración" para que los cambios queden activos.',"info")
        }
                
        initialConfigCommonJS.operarMenuLateral("cerrar")
      }



    }    
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("Debes rellenar todos los campos.","negative")
    }

  }

  function setearPrecioTarifa(){

    document.getElementById("precioCompraKw").value = ""

    var valorSeleccionadoCombo = document.getElementById("selectTarifa").value

    if(valorSeleccionadoCombo === "OCTOPUS-FLEXI"){

      document.getElementById("precioCompraKw").value = "OCTOPUS-FLEXI"

      document.getElementById("theadTarifasEnergia").className = document.getElementById("theadTarifasEnergia").className.replaceAll(" hidden", "")
      document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "")     

      document.getElementById("trTarifaEnergiaP1").className = document.getElementById("trTarifaEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaEnergiaP2").className = document.getElementById("trTarifaEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaEnergiaP3").className = document.getElementById("trTarifaEnergiaP3").className.replaceAll(" hidden", "")

      document.getElementById("tarifaEnergiaP1").innerHTML = "Octopus Flexi"
      document.getElementById("tarifaEnergiaP2").innerHTML = "Octopus Flexi"
      document.getElementById("tarifaEnergiaP3").innerHTML = "Octopus Flexi"

      if(localStorage.getItem("installationConfigurationMode") !== null){
        initialConfigCommonJS.mostrarMensajeInformativo('Recuerda usar el botón "Guardar configuración" para que los cambios queden activos.',"info")
      }   
      
      initialConfigCommonJS.operarMenuLateral("cerrar")

    }
    else if(valorSeleccionadoCombo === "LUCERA-VARIABLE"){

      document.getElementById("precioCompraKw").value = "LUCERA-VARIABLE"

      document.getElementById("theadTarifasEnergia").className = document.getElementById("theadTarifasEnergia").className.replaceAll(" hidden", "")
      document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "")     

      document.getElementById("trTarifaEnergiaP1").className = document.getElementById("trTarifaEnergiaP1").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaEnergiaP2").className = document.getElementById("trTarifaEnergiaP2").className.replaceAll(" hidden", "")
      document.getElementById("trTarifaEnergiaP3").className = document.getElementById("trTarifaEnergiaP3").className.replaceAll(" hidden", "")

      document.getElementById("tarifaEnergiaP1").innerHTML = "Lucera - A precio de coste"
      document.getElementById("tarifaEnergiaP2").innerHTML = "Lucera - A precio de coste"
      document.getElementById("tarifaEnergiaP3").innerHTML = "Lucera - A precio de coste"

      if(localStorage.getItem("installationConfigurationMode") !== null){
        initialConfigCommonJS.mostrarMensajeInformativo('Recuerda usar el botón "Guardar configuración" para que los cambios queden activos.',"info")
      }   
      
      initialConfigCommonJS.operarMenuLateral("cerrar")

    }
    else{

      var datosCorrectos = true
      var camposVisiblesVacios = 0

      for(var z=0; z<6; z++){
        
        if( !document.getElementById("trP"+(z+1)).className.includes(" hidden") && document.getElementById("precioP"+(z+1)).value === "" ){
          document.getElementById("precioP"+(z+1)).className = document.getElementById("precioP"+(z+1)).className.replaceAll(" error","") + " error"
          camposVisiblesVacios++
        }

      }

      if(camposVisiblesVacios === 0){
        
        var camposTarifas = 0

        for(var x=0; x<6; x++){
          if(document.getElementById("precioP"+(x+1)).value.toString() !== ""){
            document.getElementById("precioCompraKw").value = document.getElementById("precioCompraKw").value + document.getElementById("precioP"+(x+1)).value + "#"
            camposTarifas++
            
            document.getElementById("precioP"+(x+1)).value = document.getElementById("precioP"+(x+1)).value.replaceAll(" ","").replaceAll(",",".")

            if( parseFloat(document.getElementById("precioP"+(x+1)).value) >= 0.5){
              initialConfigCommonJS.mostrarMensajeInformativo("Alguna de las tarifas son incorrectas. Normalmente son valores de céntimos inferiores a 0,5€.","negative")
              datosCorrectos = false        
            }
          }
        }

        if(datosCorrectos){

          if(document.getElementById("precioCompraKw").value.charAt(document.getElementById("precioCompraKw").value.length - 1) === "#"){
            document.getElementById("precioCompraKw").value = document.getElementById("precioCompraKw").value.substring(0,(document.getElementById("precioCompraKw").value.length - 1))
          }

          initialConfigCommonJS.mostrarTarifasEnTabla(document.getElementById("precioCompraKw").value)         
          document.getElementById("theadTarifasEnergia").className = document.getElementById("theadTarifasEnergia").className.replaceAll(" hidden", "")
          document.getElementById("tablaTarifasContratadas").className = document.getElementById("tablaTarifasContratadas").className.replaceAll(" hidden", "")

          if(camposTarifas === 1){
            document.getElementById("spanTarifaP1").innerHTML ="P1 : Punta | Llano | Valle"      
            
            if(document.getElementById("potenciaContratada").value.split("#").length === 6){
              document.getElementById("spanTarifaP1").innerHTML ="P1, P2, P3, P4, P5, P6 :"      
            }
            
          }  
          else if(camposTarifas === 2){
            document.getElementById("spanTarifaP1").innerHTML ="P1 : Punta | Llano"
            document.getElementById("spanTarifaP2").innerHTML ="P2 : Valle"
          }  
          else if(camposTarifas === 3){
            document.getElementById("spanTarifaP1").innerHTML ="P1 : Punta"
            document.getElementById("spanTarifaP2").innerHTML ="P2 : Llano"
            document.getElementById("spanTarifaP3").innerHTML ="P3 : Valle"
          }  
          else if( (camposTarifas === 4) || (camposTarifas === 5) || (camposTarifas === 6) ){
            document.getElementById("spanTarifaP1").innerHTML ="P1 :"
            document.getElementById("spanTarifaP2").innerHTML ="P2 :"
            document.getElementById("spanTarifaP3").innerHTML ="P3 :"
            document.getElementById("spanTarifaP4").innerHTML ="P4 :"
            document.getElementById("spanTarifaP5").innerHTML ="P5 :"
            document.getElementById("spanTarifaP6").innerHTML ="P6 :"
          }  

          if(localStorage.getItem("installationConfigurationMode") !== null){
            initialConfigCommonJS.mostrarMensajeInformativo('Recuerda usar el botón "Guardar configuración" para que los cambios queden activos.',"info")
          }   
          
          initialConfigCommonJS.operarMenuLateral("cerrar")
        }

      }    
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("Debes rellenar todos los campos.","negative")
      }
    }    

  }

  function eliminarFilaPotencia(P){

    document.getElementById("Potencia"+(P)).value = ""
    document.getElementById("precioPotencia"+(P)).value = ""
    document.getElementById("Potencia"+(P)).className = document.getElementById("Potencia"+(P)).className.replaceAll(" error","")
    document.getElementById("precioPotencia"+(P)).className = document.getElementById("precioPotencia"+(P)).className.replaceAll(" error","")
    document.getElementById("trPotencia"+(P)).className = document.getElementById("trPotencia"+(P)).className.replaceAll(" hidden","") + " hidden"

    if(P === "P2"){
      document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta | Llano | Valle"
    }

    if(P === "P3"){
      document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta | Llano"
      document.getElementById("spanCalculadoraPotenciaP2").innerHTML ="P2 : Valle"
    }  

    if(P === "P4"){
      document.getElementById("spanCalculadoraPotenciaP1").innerHTML ="P1 : Punta"      
      document.getElementById("spanCalculadoraPotenciaP2").innerHTML ="P2 : Llano"
      document.getElementById("spanCalculadoraPotenciaP3").innerHTML ="P3 : Valle"
    }

    if(P === "P6"){
      document.getElementById("botonAñadirPPotencia").className = document.getElementById("botonAñadirPPotencia").className.replaceAll(" hidden", "")
    }  

  }

  function eliminarFilaTarifa(P){    
    document.getElementById("precio"+(P)).value = ""    
    document.getElementById("precio"+(P)).className = document.getElementById("precio"+(P)).className.replaceAll(" error","")
    document.getElementById("tr"+(P)).className = document.getElementById("tr"+(P)).className.replaceAll(" hidden","") + " hidden"

    if( (P === "P3") || (P === "P6")){
      document.getElementById("botonAñadirP").className = document.getElementById("botonAñadirP").className.replaceAll(" hidden", "")
    }  

    var listadoTrsPs = document.getElementById("listadoPs").querySelectorAll("tr")
    var filasVisibles = 0    

    for(var x=0; x < listadoTrsPs.length; x++){          
      if(!document.getElementById(listadoTrsPs[x].id).className.includes(" hidden")){
        filasVisibles++
      }
    }

    if(filasVisibles === 1){
      document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta | Llano | Valle"  
      
      if(document.getElementById("potenciaContratada").value.split("#").length === 6){
        document.getElementById("spanTarifasP1").innerHTML ="P1, P2, P3, P4, P5, P6 :"        
      }    
    }
    else if(filasVisibles === 2){
      document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta | Llano"      
      document.getElementById("spanTarifasP2").innerHTML ="P2 : Valle"  
      
      if(document.getElementById("potenciaContratada").value.split("#").length === 6){
        document.getElementById("spanTarifasP1").innerHTML ="P1 :"      
        document.getElementById("spanTarifasP2").innerHTML ="P2 :"                    
      }

    }
    else if(filasVisibles === 3){
      document.getElementById("spanTarifasP1").innerHTML ="P1 : Punta"      
      document.getElementById("spanTarifasP2").innerHTML ="P2 : Llano"      
      document.getElementById("spanTarifasP3").innerHTML ="P3 : Valle"      

      if(document.getElementById("potenciaContratada").value.split("#").length === 6){
        document.getElementById("spanTarifasP1").innerHTML ="P1 :"      
        document.getElementById("spanTarifasP2").innerHTML ="P2 :"              
        document.getElementById("spanTarifasP3").innerHTML ="P3 :"         
      }

    }
    else if( (filasVisibles === 4) || (filasVisibles === 5) || (filasVisibles === 6) ){
      document.getElementById("spanTarifasP1").innerHTML ="P1 :"
      document.getElementById("spanTarifasP2").innerHTML ="P2 :"
      document.getElementById("spanTarifasP3").innerHTML ="P3 :"
      document.getElementById("spanTarifasP4").innerHTML ="P4 :"
      document.getElementById("spanTarifasP5").innerHTML ="P5 :"
      document.getElementById("spanTarifasP6").innerHTML ="P6 :"
    }

  }

  function activarBotonGuardado(){
    
    if(document.getElementById("direccionUbicacion").value !== null){
      if(document.getElementById("direccionUbicacion").value !== ""){
        document.getElementById("botonGuardarUbicacion").disabled = false
        document.getElementById("botonGuardarUbicacion").onclick = guardarUbicacion
      }
      else{
        document.getElementById("botonGuardarUbicacion").disabled = true
      }
    }

  }

  function guardarUbicacion(){

    if ( (document.getElementById("codigoPostalUbicacion").value.toString() !== "") && (document.getElementById("latitudUbicacion").value.toString() !== "") && (document.getElementById("longitudUbicacion").value.toString() !== "") ){

      document.getElementById("direccion").value = document.getElementById("direccionUbicacion").value
      document.getElementById("codigoPostal").value = document.getElementById("codigoPostalUbicacion").value
      document.getElementById("idMunicipioActual").value = document.getElementById("latitudUbicacion").value+"|"+document.getElementById("longitudUbicacion").value
      initialConfigCommonJS.operarMenuLateral("cerrar")   

    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("Debes indicar el código postal o una dirección más concreta del municipio.","negative")
    }      

  }

  return (    
    <aside id="menuLateral" className="modal hidden">      
            
      <div id="divContenedorOpcionesApps" className="modal-content">
        <button className="link close" onClick={() => initialConfigCommonJS.operarMenuLateral("cerrar")}><span className="material-icon">highlight_off</span></button>
        
        <div id="listadoAplicacionesConfiguradas" className="page" >            
          <ConfiguredApplicationsList appsList={availableApps} setAvailableApps={setAvailableApps} setAppToRegister={setAppToRegister} setAvailableDevices={setAvailableDevices} setDeletionConflictDevices={setDeletionConflictDevices} setSelecteDeviceToConfigure={setSelecteDeviceToConfigure}/>            
        </div>

        <div id="errorBorradoAplicacion" className="page" style={{display: 'none'}}>            
          <button id="botonAtrasErrorBorradoAplicacion" className="link back" onClick={() => initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoAplicacionesConfiguradas","noUpdate")}><span className="material-icon">arrow_back</span>Volver</button>
          <AppDeletionError AppName={appToRegister} deletionConflictDevices={deletionConflictDevices} appsList={availableApps} setAvailableApps={setAvailableApps} setAppToRegister={setAppToRegister} setAvailableDevices={setAvailableDevices}/>                
        </div>

        <div id="listadoAplicacionesDisponibles" className="page" style={{display: 'none'}}>
          { localStorage.getItem("installationConfigurationMode") === null
          ? <button id="botonAtrasAppsDisponibles" className="link back" onClick={() => initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoAplicacionesConfiguradas","noUpdate")}><span className="material-icon">arrow_back</span>Volver</button>
          : <></>
          }
          
          <AvailableApplicationsList setAppToRegister={setAppToRegister} appsList={availableApps} setAppToConsult={params.setAppToConsult} selecteDeviceToConfigure={selecteDeviceToConfigure} setSelecteDeviceToConfigure={setSelecteDeviceToConfigure}/>
        </div>

        <div id="formularioRegistroAplicacion" className="page" style={{display: 'none'}}>
          <button className="link back" onClick={() => initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoAplicacionesDisponibles","noUpdate")}><span className="material-icon">arrow_back</span>Volver</button>
          <AppRegistrationForm AppName={appToRegister} setAvailableApps={setAvailableApps} setAvailableDevices={setAvailableDevices} setDevicesList={params.setDevicesList} setDevicesApps={params.setDevicesApps}/>
        </div>

        <div id="listadoDispositivosDisponibles" className="page" style={{display: 'none'}}>
          <button id="botonAtrasDispositivosDisponibles" className="link back" onClick={() => initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoAplicacionesConfiguradas","noUpdate")}><span className="material-icon">arrow_back</span>Volver</button>
          <AvailableDevicesList AppName={appToRegister} setAvailableApps={setAvailableApps} setAppToRegister={setAppToRegister} devicesList={availableDevices} setDevicesApps={params.setDevicesApps} setDeletionConflictDevices={setDeletionConflictDevices}/>                
        </div>

        <div id="divCalculadoraPotencia" className="page" style={{display: 'none'}}>

          <header>
              <figure className="avatar size-m pink">                
                  <span id="iconoDetalleWidget" className="material-icon">calculate</span>
              </figure>
              
              <h1 className="headline-03">Configuración de potencia</h1>
              
          </header>

          <div className="vertical gap-04">

            <div className="vertical gap-04">
              <p>Busca en tu factura el apartado de <strong>"Término de potencia"</strong> o <strong>"Potencia facturada"</strong>. Ten en cuenta que el precio que debes introducir es <strong>€/kW Día SIN IVA</strong>.</p>    
              <img src={imgCalculadoraPotencias} width={"100%"} alt="Imagen Tarifas"/>                        
            </div>  

            <div>
                <table>
                    <thead>
                        <tr className="table-row">                                            
                            <th className="table-cell"></th>
                            <th className="table-cell value">Potencia</th>
                            <th className="table-cell value">Tarifa</th>
                        </tr>
                    </thead>
                    <tbody id="listadoPsPotencia">

                        <tr id="trPotenciaP1" className="table-row vertical-start">
                            
                            <td className="table-cell vertical-center">
                              <span id="spanCalculadoraPotenciaP1">P1 : Punta + Llano + Valle</span>
                            </td>

                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="kW">
                                <input type="text" inputMode="decimal" id="PotenciaP1"/>
                              </fieldset>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="€/kW">
                                <input type="text" inputMode="decimal" id="precioPotenciaP1"/>
                              </fieldset>
                            </td>     
                            <td className="table-cell vertical-center value"></td>                       
                        </tr>
                        <tr id="trPotenciaP2" className="table-row vertical-start hidden">
                            <td className="table-cell vertical-center">                                
                                <span id="spanCalculadoraPotenciaP2">P2 : Valle</span>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="kW">
                                <input type="text" inputMode="decimal" id="PotenciaP2"/>
                              </fieldset>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="€/kW">
                                <input type="text" inputMode="decimal" id="precioPotenciaP2"/>
                              </fieldset>
                            </td>
                            <td className="table-cell vertical-center value">
                              <button onClick={() => eliminarFilaPotencia("P2")}><span className="material-icon red">highlight_off</span></button>
                            </td>
                        </tr>
                        <tr id="trPotenciaP3" className="table-row vertical-start hidden">
                            <td className="table-cell vertical-center ">                                
                              <span id="spanCalculadoraPotenciaP3">P3 : Valle</span>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="kW">
                                <input type="text" inputMode="decimal" id="PotenciaP3"/>
                              </fieldset>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="€/kW">
                                <input type="text" inputMode="decimal" id="precioPotenciaP3"/>
                              </fieldset>
                            </td>
                            <td className="table-cell vertical-center value">
                              <button onClick={() => eliminarFilaPotencia("P3")}><span className="material-icon red">highlight_off</span></button>
                            </td>
                        </tr>
                        <tr id="trPotenciaP4" className="table-row vertical-start hidden">
                            <td className="table-cell vertical-center ">
                              <span>P4 :</span>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="kW">
                                <input type="text" inputMode="decimal" id="PotenciaP4"/>
                              </fieldset>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="€/kW">
                                <input type="text" inputMode="decimal" id="precioPotenciaP4"/>
                              </fieldset>
                            </td>
                            <td className="table-cell vertical-center value">
                              <button onClick={() => eliminarFilaPotencia("P4")}><span className="material-icon red">highlight_off</span></button>
                            </td>
                        </tr>
                        <tr id="trPotenciaP5" className="table-row vertical-start hidden">
                            <td className="table-cell vertical-center "> 
                              <span>P5 :</span> 
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="kW">
                                <input type="text" inputMode="decimal" id="PotenciaP5"/>
                              </fieldset>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="€/kW">
                                <input type="text" inputMode="decimal" id="precioPotenciaP5"/>
                              </fieldset>
                            </td>
                            <td className="table-cell vertical-center value">
                              <button onClick={() => eliminarFilaPotencia("P5")}><span className="material-icon red">highlight_off</span></button>
                            </td>
                        </tr>
                        <tr id="trPotenciaP6" className="table-row vertical-start hidden">
                            <td className="table-cell vertical-center ">
                              <span>P6 :</span>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="kW">
                                <input type="text" inputMode="decimal" id="PotenciaP6"/>
                              </fieldset>
                            </td>
                            <td className="table-cell value">
                              <fieldset className="icon-wrapper data" data-label="€/kW">
                                <input type="text" inputMode="decimal" id="precioPotenciaP6"/>
                              </fieldset>
                            </td>
                            <td className="table-cell vertical-center value">
                              <button onClick={() => eliminarFilaPotencia("P6")}><span className="material-icon red">highlight_off</span></button>
                            </td>
                        </tr>                        
                    </tbody>

                </table>

            </div>

            <ul className="actions horizontal-center">              
              <li><button  id="botonAñadirPPotencia" className="link full-width" onClick={ () => initialConfigCommonJS.añadirPPotencia()}>Añadir otro tramo (P)</button></li>
            </ul>
            
            <fieldset>
              <button className="button primary full-width" type="button" onClick={ () => setearPrecioPotencia()}>Continuar</button> 
            </fieldset>   

          </div>


        </div>

        <div id="divCalculadoraTarifa" className="page" style={{display: 'none'}}>

          <header>
              <figure className="avatar size-m pink">                
                  <span id="iconoDetalleWidget" className="material-icon">calculate</span>
              </figure>
              
              <h1 className="headline-03">Configuración de tarifa</h1>
              
          </header>

          <div className="vertical gap-04">

          <fieldset id="fieldsetSelectTarifa" className="dropdown hidden">
            <label htmlFor="selectTarifa">Selecciona tu tarifa</label>
            <div className="icon-wrapper">
              <select id="selectTarifa" onChange={ () => initialConfigCommonJS.actualizarFormularioTarifasCombo()}>
                <option value="FIJA">Tengo otra</option>
                <option value="OCTOPUS-FLEXI">Octopus - Flexi (Indexada)</option>
                <option value="LUCERA-VARIABLE">Lucera - A precio de coste (Indexada)</option>                
              </select>
            </div>
          </fieldset>

            <div id="formularioTarifasFijas" className=" hidden">
              <div className="vertical gap-04">
                <p>Busca en tu factura el apartado de <strong>"Término de energía variable"</strong> o <strong>"Energía facturada"</strong> y recuerda que el precio es en <strong>€/kWh SIN IVA</strong>.</p><p><strong>Si tienes una tarifa que cambia cada mes</strong> introduce en todos los campos el <strong>precio medio del kWh del último año</strong>. Si no aparece este dato en tu factura pregúntale a tu comercializadora.</p>    
                <img src={imgCalculadoraTarifas} width={"100%"} alt="Imagen Tarifas"/>                        
              </div>  

              <div>
                  <table>
                      <thead>
                          <tr className="table-row">                                            
                              <th className="table-cell"></th>
                              <th className="table-cell value">Tarifa</th>
                          </tr>
                      </thead>
                      <tbody id="listadoPs">

                          <tr id="trP1" className="table-row vertical-start">
                              
                              <td className="table-cell vertical-center ">
                                <span id="spanTarifasP1">P1 : Punta + Llano + Valle</span>
                              </td>
                              <td className="table-cell value">
                                <fieldset className="icon-wrapper data" data-label="€/kWh">
                                  <input type="text" inputMode="decimal" id="precioP1"/>
                                </fieldset>
                              </td>     
                              <td className="table-cell vertical-center value"></td>                       
                          </tr>
                          <tr id="trP2" className="table-row vertical-start hidden">
                              <td className="table-cell vertical-center ">                                
                                  <span id="spanTarifasP2">P2 : Llano</span>
                              </td>
                              <td className="table-cell value">
                                <fieldset className="icon-wrapper data" data-label="€/kWh">
                                  <input type="text" inputMode="decimal" id="precioP2"/>
                                </fieldset>
                              </td>
                              <td className="table-cell vertical-center value">
                                <button onClick={() => eliminarFilaTarifa("P2")}><span className="material-icon red">highlight_off</span></button>
                              </td>
                          </tr>
                          <tr id="trP3" className="table-row vertical-start hidden">
                              <td className="table-cell vertical-center ">                                
                                <span id="spanTarifasP3">P3 : Valle</span>
                              </td>
                              <td className="table-cell value">
                                <fieldset className="icon-wrapper data" data-label="€/kWh">
                                  <input type="text" inputMode="decimal" id="precioP3"/>
                                </fieldset>
                              </td>
                              <td className="table-cell vertical-center value">
                                <button onClick={() => eliminarFilaTarifa("P3")}><span className="material-icon red">highlight_off</span></button>
                              </td>
                          </tr>                        
                          <tr id="trP4" className="table-row vertical-start hidden">
                              <td className="table-cell vertical-center ">                                
                                <span id="spanTarifasP4">P4 :</span>
                              </td>
                              <td className="table-cell value">
                                <fieldset className="icon-wrapper data" data-label="€/kWh">
                                  <input type="text" inputMode="decimal" id="precioP4"/>
                                </fieldset>
                              </td>
                              <td className="table-cell vertical-center value">
                                <button onClick={() => eliminarFilaTarifa("P4")}><span className="material-icon red">highlight_off</span></button>
                              </td>
                          </tr>                        
                          <tr id="trP5" className="table-row vertical-start hidden">
                              <td className="table-cell vertical-center ">                                
                                <span id="spanTarifasP5">P5 :</span>
                              </td>
                              <td className="table-cell value">
                                <fieldset className="icon-wrapper data" data-label="€/kWh">
                                  <input type="text" inputMode="decimal" id="precioP5"/>
                                </fieldset>
                              </td>
                              <td className="table-cell vertical-center value">
                                <button onClick={() => eliminarFilaTarifa("P5")}><span className="material-icon red">highlight_off</span></button>
                              </td>
                          </tr>                        
                          <tr id="trP6" className="table-row vertical-start hidden">
                              <td className="table-cell vertical-center ">                                
                                <span id="spanTarifasP6">P6 :</span>
                              </td>
                              <td className="table-cell value">
                                <fieldset className="icon-wrapper data" data-label="€/kWh">
                                  <input type="text" inputMode="decimal" id="precioP6"/>
                                </fieldset>
                              </td>
                              <td className="table-cell vertical-center value">
                                <button onClick={() => eliminarFilaTarifa("P6")}><span className="material-icon red">highlight_off</span></button>
                              </td>
                          </tr>                        
                      </tbody>

                  </table>

              </div>

              <ul className="actions horizontal-center">              
                <li><button  id="botonAñadirP" className="link full-width" onClick={ () => initialConfigCommonJS.añadirPTarifa()}>Añadir otro tramo (P)</button></li>
              </ul>
            </div>

            <fieldset>
              <button className="button primary full-width" type="button" onClick={ () => setearPrecioTarifa()}>Continuar</button> 
            </fieldset>   

          </div>


        </div>

        <div id="divConfigurarSinDireccion" className="modal-content" style={{display: 'none'}}>

          <button className="link close" onClick={() => initialConfigCommonJS.operarMenuLateral("cerrar")}><span className="material-icon">cancel</span></button>
          <header>
              <figure className="avatar size-m orange"><span className="material-icon">place</span></figure>
              <h1 className="headline-03">Localiza tu instalación</h1>
          </header> 

          <section className="weather-devices fill gap-04">    

            <p>Escribe el nombre del municipio más cercano, busca tu instalación usando el mapa y pulsa en ella para colocar la chincheta.</p> 

            <div className="text">
              <LoadScript googleMapsApiKey={"AIzaSyAKzBBmfUcgXRb4q_uUmLtZDUS9aedgsX4"} libraries={["places"]}>
                <StandaloneSearchBox
                    onLoad={ref => inputRef.current = ref}
                    placeholder=" "                        
                    onPlacesChanged={handlePlaceChanged}                        
                >
                  <input
                      id="direccionUbicacion"
                      type="text"
                      placeholder="Ej: Madrid"
                      onKeyDown={e => { 
                        document.getElementById("municipio").value = ""
                        document.getElementById("codigoPostal").value = ""
                        document.getElementById("idMunicipioActual").value = ""
                        if (e.keyCode === 13) {activarBotonGuardado(); }}                            
                      }
                      onBlur={() => activarBotonGuardado()}
                  />
                </StandaloneSearchBox>
              </LoadScript>
            </div>

            <section id="seccionMapa" className="weather-map"> 
              <LoadScript googleMapsApiKey={"AIzaSyAKzBBmfUcgXRb4q_uUmLtZDUS9aedgsX4"} libraries={["places"]}>
                <GoogleMapComponentLocation mapId={"mapaUbicacionInstalacion"} coordenadas={params.selectedLocation} activarBotonGuardado={activarBotonGuardado} markers={markers} setMarkers={setMarkers}/>              
              </LoadScript>
            </section>
            
            <fieldset>
              <button id="botonGuardarUbicacion" className="button primary full-width" onClick={() => guardarUbicacion()} disabled>Continuar</button>        
            </fieldset> 

            <fieldset className="text hidden">                    
              <input type="text" id="codigoPostalUbicacion"/>
              <input type="text" id="latitudUbicacion"/> 
              <input type="text" id="longitudUbicacion"/> 
            </fieldset>

          </section>        

        </div>

      </div>
      
    </aside>   
  )
}

export default AsideMenu